import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './styles/global.css';
import './styles/ui.css';
import './styles/controls.css';
import './styles/screens.css';
import './styles/admin.css';
import { App } from './App.js';
import { trackViewportHeight } from './lib/viewport.js';

trackViewportHeight();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// A house app that shows stale controls is worse than one that reloads, so new
// builds are taken immediately rather than waiting for every tab to close.
const updateSW = registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    // An installed app that is resumed rather than launched never re-checks on
    // its own, so a deploy could sit unnoticed for days. Ask on every return to
    // the foreground; the browser no-ops when nothing has changed.
    const check = (): void => {
      if (document.visibilityState === 'visible') void registration.update();
    };
    document.addEventListener('visibilitychange', check);
    window.setInterval(check, 60 * 60 * 1000);
  },
});
void updateSW;
